import * as React from "react";
import { ChromaFlareScene } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/ChromaFlare/ChromaFlareScene";
import * as styles from "./QuickJournalChromaFlare.css";

export function QuickJournalChromaFlare({ upper = false, isPaused = false }: {
    upper?: boolean; isPaused?: boolean;
}) {
    if (upper) return <div aria-hidden="true" className={styles.upper} data-paused={isPaused || undefined}>
        <span className={styles.glassLeft} />
        <span className={styles.glassRight} />
        <span className={styles.refraction} />
        <span className={styles.glint} />
        {[
            ["15%", "25%", "34px", "-4s"],
            ["26%", "64%", "20px", "-13s"],
            ["89%", "35%", "28px", "-8s"],
            ["8%", "85%", "15px", "-18s"],
            ["94%", "74%", "18px", "-2s"],
        ].map(([left, top, width, delay], index) => <span key={index} className={styles.facet}
            style={{ left, top, width, animationDelay: delay }} />)}
    </div>;

    return <div aria-hidden="true" className={styles.lower}>
        <ChromaFlareScene className={styles.scene} isPaused={isPaused} />
    </div>;
}
